<template>
    <div></div>
</template>

<script>
export default {
  name: 'MessageBoxComponent',
  methods: {
    qcMessageBox ({ title, text, f, c }) {
      this.$confirm(text, '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'qcMessageBoxCss'
      }).then(() => {
        f()
      }).catch(() => {
        if (c) {
          c()
        }
      })
    }
  },
  mounted() {
    window.qcMessageBox = this.qcMessageBox
  }
}
</script>

<style>
    .qcMessageBoxCss>.el-message-box__header>.el-message-box__title {
       font-size: 18px;
    }
</style>
